export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4603.4845ef92.jpg";